export function TagInput({ tags, tagInput, setTagInput, onAdd, onRemove }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Tags</label>
      <div className="flex items-center gap-2">
        <input type="text" value={tagInput} onChange={(e) => setTagInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onAdd(); } }} placeholder="Type tag, press Enter" className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#014DB7]/30" />
        <button type="button" onClick={onAdd} className="px-3 py-2 border rounded-lg text-sm text-gray-600 hover:bg-gray-50">Add</button>
      </div>
      {tags.length > 0 && <TagList tags={tags} onRemove={onRemove} />}
    </div>
  );
}

function TagList({ tags, onRemove }) {
  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {tags.map(t => <TagPill key={t} text={t} onRemove={() => onRemove(t)} />)}
    </div>
  );
}

function TagPill({ text, onRemove }) {
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#014DB7]/10 text-[#014DB7] rounded text-xs font-medium">
      {text}
      <button onClick={onRemove} className="hover:text-red-500 ml-0.5">x</button>
    </span>
  );
}
